import React from 'react';
import './Header.css';
import {Avatar, Icon, Button} from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import NotificationsIcon from '@material-ui/icons/Notifications';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PhotoIcon from '@material-ui/icons/Photo';
import {Dropdown} from 'react-bootstrap';
import {Link} from "react-router-dom";

function Header({username, profilePic, userId, menuOpen, messOpen, firstname}) {
    return (
        <div className="header">
            <div className="header__left">
                <Button 
                onClick={menuOpen}
                ><MenuOpenIcon /></Button>
                <Link to ="/">
                <img src="https://firebasestorage.googleapis.com/v0/b/memory-393e8.appspot.com/o/logo%2Flogo.png?alt=media&token=f7fda31f-113e-4148-a782-0e71dddc117d" />
                </Link>
            </div>
            <div className="header__center">
                <Link to="/">
                    <Button className="home__icon"><HomeIcon /></Button>
                </Link>
                <Link to={`/story/${userId}`} >
                    <Button><MenuBookIcon/></Button>
                </Link>
                <Link to={`/photo/${userId}`} >
                    <Button className="photo__icon"><PhotoIcon/></Button>
                </Link>
                <Link to={`/video/${userId}`} >
                    <Button className="video__icon"><VideoLibraryIcon /></Button>
                </Link>
                <Link to={`/movie/${userId}`} >
                    <Button className="movie__icon"><MovieCreationIcon /></Button>
                </Link>
                <Link to={`/shop/${userId}`} >
                    <Button><LocalMallIcon /></Button>
                </Link>
                <Button><PersonAddIcon /> </Button>
            </div>
            <div className="header__right">
                <Link to={`/account/${userId}`} >
                    <Button className="header__profile"><Avatar src={profilePic} className="header__avatar"/>
                <p>{firstname}</p> </Button> </Link>
                <Button 
                onClick={messOpen}
                > <img 
                src="https://firebasestorage.googleapis.com/v0/b/memory-393e8.appspot.com/o/logo%2Fmessenger.jpg?alt=media&token=6fcecf3b-0668-47c0-8b70-0183f926b092" 
                width="24px"
                style={{filter:"invert(0.8)"}}
                /> </Button>
                <Button><NotificationsIcon /></Button>
                <Dropdown className="more__down m__down header__dow">
                    <Dropdown.Toggle className="more__expand header__down" id="dropdown-basic">
                        <Button><ArrowDropDownIcon /></Button>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item > Change Password</Dropdown.Item>
                        <Dropdown.Item > Logout?</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    )
}

export default Header
